import { 
  cilMenu, 
  cilSpeedometer, 
  cilChatBubble, 
  cilSend, 
  cilCheckCircle, 
  cilNewspaper,
  cilTask,
  cilListRich,
  cilUser,
  cilUserPlus,
  cilBackspace,
  cilUserX,
  cilLoopCircular,
  cilLockLocked,
  cilPencil,
  cilX,
  cilArrowThickToRight,
  cilArrowCircleRight,
  cilTrash,
  cilHistory,
  cilAccountLogout,
  cilWarning,
  cilInfo,
  cilArrowThickLeft,
  cilArrowThickRight,
  cilFile,
  cilMediaStop,
  cilChart,
  cilXCircle,
  cilReportSlash,
  cilShareAll,
  cilLibraryAdd,
  cilDescription,
  cilCheck
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {},
  {
    cilMenu,
    cilSpeedometer,
    cilChatBubble,
    cilSend,
    cilCheckCircle,
    cilNewspaper,
    cilTask,
    cilListRich,
    cilUser,
    cilUserPlus,
    cilBackspace,
    cilUserX,
    cilLoopCircular,
    cilLockLocked,
    cilPencil,
    cilX,
    cilArrowThickToRight,
    cilArrowCircleRight,
    cilTrash,
    cilHistory,
    cilAccountLogout,
    cilWarning,
    cilInfo,
    cilArrowThickLeft,
    cilArrowThickRight,
    cilFile,
    cilMediaStop,
    cilChart,
    cilXCircle,
    cilReportSlash,
    cilShareAll,
    cilLibraryAdd,
    cilDescription,
    cilCheck
  },
)
